// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunctionOutlinedSvg from "@fishx/icons-svg/es/asn/FunctionOutlined";
import FishxIcon from '../components/FishxIcon';

var FunctionOutlined = function FunctionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunctionOutlinedSvg
  }));
};

FunctionOutlined.displayName = 'FunctionOutlined';
export default React.forwardRef(FunctionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FunctionOutlined.js
// module id = 2839
// module chunks = 0